// packages/client/src/components/project/miller/NewSetModal.tsx
import { useState } from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, Input } from '@heroui/react';
import { useCreateDrawingSet } from '@/api/drawing-sets';

interface NewSetModalProps {
  isOpen: boolean;
  onClose: () => void;
  projectId: string;
  folderId: string;
}

export default function NewSetModal({ isOpen, onClose, projectId, folderId }: NewSetModalProps) {
  const [name, setName] = useState('');
  const createSet = useCreateDrawingSet(projectId);

  const handleSubmit = async () => {
    if (!name.trim()) return;
    await createSet.mutateAsync({ name: name.trim(), folder_id: folderId });
    setName('');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <ModalContent>
        <ModalHeader>
          <h3 className="text-sm font-semibold" style={{ color: 'var(--text-primary)' }}>
            New Drawing Set
          </h3>
        </ModalHeader>
        <ModalBody>
          <Input
            label="Set Name"
            placeholder="e.g. Kitchen Casework Set"
            value={name}
            onValueChange={setName}
            size="sm"
            autoFocus
          />
        </ModalBody>
        <ModalFooter>
          <Button size="sm" variant="light" onPress={onClose}>Cancel</Button>
          <Button
            size="sm"
            color="primary"
            onPress={handleSubmit}
            isDisabled={!name.trim()}
            isLoading={createSet.isPending}
          >
            Create
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
